import { Close } from "@mui/icons-material";
import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";

const EventJoinedSuccess = ({ open, handleClose }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            height: "50px",
            width: "50px",
            borderRadius: "9px",
            backgroundColor: "rgba(247,132,25,0.05)",
            alignSelf: "flex-end",
            position: "absolute",
            top: "5%",
            right: "2.5%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.2)",
            },
          }}
          onClick={handleClose}
        >
          <Close sx={{ color: colors.secondary, fontSize: "30px" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={require("../../assets/images/success.png")}
            alt="success"
            style={{
              height: "150px",
              width: "150px",
              objectFit: "contain",
              marginBottom: "20px",
            }}
          />
          <Typography
            sx={{
              fontFamily: "Mulish-ExtraBold",
              fontSize: "18px",
              color: colors.primary,
              textAlign: "center",
              maxWidth: "75%",
            }}
          >
            You’ve joined the event successfully!
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default EventJoinedSuccess;
